import { useEffect, useRef } from "react";
import { hubBaseUrl } from "lib/hubSso";

/**
 * Thin mount for the Hub's shared BOM picker web component.
 *
 * The picker itself lives in hub360 and is served at /embed/bom-picker.js, the
 * same way the shared header is. It is not reimplemented here: the suite's
 * products build independently and share no package, so a copy in each repo
 * would drift the way the palette did — and logic drifts silently, where a
 * wrong colour at least looks wrong. It owns the whole "get me a BOM" flow:
 * list, pick, upload, and the ONE column-mapping step the suite runs.
 *
 * Emits: `pick` with detail { id, name, lineCount, projectId, projectName, projectCode }.
 */
const SCRIPT_ID = "semi360-bom-picker-embed";

export default function HubBomPicker({ onPick }) {
  const hostRef = useRef(null);

  useEffect(() => {
    if (!document.getElementById(SCRIPT_ID)) {
      const s = document.createElement("script");
      s.id = SCRIPT_ID;
      s.src = `${hubBaseUrl()}/embed/bom-picker.js`;
      s.async = true;
      document.head.appendChild(s);
    }
    const host = hostRef.current;
    if (!host) return undefined;
    if (!host.firstChild) host.appendChild(document.createElement("semi360-bom-picker"));
    const handler = (e) => onPick(e.detail);
    host.addEventListener("pick", handler);
    return () => host.removeEventListener("pick", handler);
  }, [onPick]);

  return <div ref={hostRef} />;
}
